/**
 * Filter out users where active = false and transform back to key/value pairs
 *
 * Input: { 1: {id: 1, firstName: 'Bob', active: true}, 2: {id: 2, firstName: 'Ross', active: false} }
 * Output: { 1: {id: 1, firstName: 'Bob', active: true} }
 *
 * @param users - key/value pairs
 */
export const removeInactiveUsers = (users) => {
  return Object.keys(users)
    .filter(id => users[id].active)
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: users[key],
      };
    }, {});
};

// System messages do not have a sender ID
export const isUserMessage = message => message.senderId !== null;

/*
 * Used for inbox messenger users only
 */
const INBOX_MESSENGER_MEMBER_ID = 'inboxMessengerMemberId';
export const setMemberId = memberId => localStorage.setItem(INBOX_MESSENGER_MEMBER_ID, memberId);
export const getLocalMemberId = () => localStorage.getItem(INBOX_MESSENGER_MEMBER_ID);
export const isSameMember = memberId => getLocalMemberId() === memberId.toString();
